import React from 'react';
import { Box, Stack } from '@mantine/core';
import SidebarItem, { ModuleLink } from './SidebarItem';

type Props = {
    pathPrefix: string;
    moduleLinks: ModuleLink[];
};

export default function Sidebar({ moduleLinks, pathPrefix }: Props) {
    return (
        <Box
            component="nav"
            w={78}
            h="calc(100vh - 64px)"
            className="fixed top-16 left-0 z-20 bg-white shadow-md flex flex-col"
        >
            <Stack gap={0} className="items-center h-full">
                {moduleLinks.map(link => (
                    <SidebarItem
                        link={link}
                        pathPrefix={pathPrefix}
                        key={link.path}
                    />
                ))}
            </Stack>
        </Box>
    );
}
